import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SeoState {
  title?: string
  description?: string,
  imageUrl?: string,
  siteUrl?: string,
  siteName?: string,
}

// Default state values
const initialState: Readonly<SeoState> = {
  title: 'Donate | Comic Relief',
  description: "Donate to Comic Relief. The money you donate to Comic Relief will make a huge difference to people in the UK and across the world's poorest communities",
  imageUrl: 'https://images.ctfassets.net/zsfivwzfgl3t/1rkL0dIje4d8d39mTSpS6s/4bb263984cae39f3b8ed9d7bff91d70f/CR_Logo_Red_RGB.png',
  siteName: 'Donate with Comic Relief',
};

export const seoSlice = createSlice({
  name: 'seo',
  // Pass in the default values
  initialState,
  // Pass in the functions that do things
  reducers: {
    updateSeo(state: SeoState, action: PayloadAction<Partial<SeoState>>) {
      return {
        ...state,
        ...action.payload
      };
    },
  }
});

// To make available to the rest of the application:
export const { updateSeo } = seoSlice.actions;
